/**
 * Parse int from data-attribute. You must provide attribute name without 'data-'
 * @param el
 * @param dataAttr attribute name without prefix 'data-'
 * @returns
 */
export const parseIntDataAttr = (
    el: Element,
    dataAttr: string
): number | null => {
    const value = el.getAttribute(`data-${dataAttr}`);
    if (!value) return null;
    const parsedValue = parseInt(value);
    return isNaN(parsedValue) ? null : parsedValue;
};

export function parseStringDataAttr<T extends string>(
    el: HTMLElement,
    dataAttr: string
): T | null {
    const value = el.getAttribute(`data-${dataAttr}`);
    return value as T | null;
}

export const parseBooleanDataAttr = (el: Element, dataAttr: string): boolean =>
    el.getAttribute(`data-${dataAttr}`) === "true";

export const parseOptionalBooleanDataAttr = (
    el: Element,
    dataAttr: string
): boolean | null => {
    const value = el.getAttribute(`data-${dataAttr}`);
    if (value === "true") return true;
    if (value === "false") return false;
    return null;
};

const gidRegex = /^gid:\/\/shopify\/[^/]+\/(\d+)$/;
export const parseIntFromGidDataAttr = (
    el: Element,
    dataAttr: string
): number | null => {
    gidRegex.lastIndex = 0;

    const value = el.getAttribute(`data-${dataAttr}`);
    if (!value) return null;
    const match = gidRegex.exec(value);
    if (!match) return null;
    const parsedValue = parseInt(match[1]);
    return isNaN(parsedValue) ? null : parsedValue;
};
